/* Steel Monkey cart drawer: subscribe & save toggle and quantity steppers. Works with Impact's cart events. */
(function(){
  var root=function(){return (window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/';};
  if(!customElements.get('sm-cart-sub')){
    customElements.define('sm-cart-sub',class extends HTMLElement{
      connectedCallback(){
        if(this._bound)return;this._bound=true;
        this.addEventListener('click',function(e){
          var b=e.target.closest('button[data-plan]');if(!b)return;e.preventDefault();this.setPlan(b.dataset.plan);
        }.bind(this));
        this.addEventListener('change',function(e){
          if(e.target.matches('[data-plan-select]'))this.setPlan(e.target.value);
        }.bind(this));
      }
      setPlan(plan){
        if(this._busy)return;this._busy=true;this.classList.add('is-busy');
        var li=this.closest('line-item'),err=this.querySelector('.smcs__err'),self=this;
        if(err)err.hidden=true;
        li&&li.dispatchEvent(new CustomEvent('line-item:will-change',{bubbles:true,detail:{targetQuantity:+this.dataset.qty}}));
        var sections=[];
        document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections',{bubbles:true,detail:{sections:sections}}));
        fetch(root()+'cart/change.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},
          body:JSON.stringify({id:this.dataset.key,quantity:+this.dataset.qty,selling_plan:plan?+plan:null,sections:sections})})
          .then(function(r){return r.json().then(function(j){if(!r.ok)throw j;return j;});})
          .then(function(cart){
            if(window.themeVariables&&themeVariables.settings&&themeVariables.settings.pageType==='cart'){location.reload();return;}
            document.documentElement.dispatchEvent(new CustomEvent('cart:change',{bubbles:true,detail:{baseEvent:'variant:add',cart:cart}}));
          })
          .catch(function(e){
            self._busy=false;self.classList.remove('is-busy');
            li&&li.dispatchEvent(new CustomEvent('line-item:error',{bubbles:true}));
            if(err){err.textContent=(e&&(e.description||e.message))||'Something went wrong. Please try again.';err.hidden=false;}
          });
      }
    });
  }
  if(!window.__smQty){
    window.__smQty=true;
    document.addEventListener('click',function(e){
      var b=e.target.closest&&e.target.closest('[data-sm-step]');if(!b||b.disabled)return;
      var w=b.closest('.smq'),i=w&&w.querySelector('input[data-line-key]');if(!i)return;
      e.preventDefault();
      var step=+i.step||1,cur=+i.value||0,v=cur+(+b.dataset.smStep)*step;
      if(v<1)v=1;if(i.max&&v>+i.max)v=+i.max;if(v===cur)return;
      i.value=v;w.classList.add('is-busy');
      i.dispatchEvent(new Event('change',{bubbles:true}));
    });
  }
})();
